import { generalData_Types } from "./general-data.types";

const INITIAL_STATE = {
  onlineUsers: {
    loading: false,
    data: [],
    page: 1,
    limit: 10,
  },
  onlineUsersBadge: 0,
  notifications: {},
  showNotifPopup: false,
};

/**
 * this function filters duplicate users in fetched online users list
 *
 * @param {Array} fetchedList - newly fetched list of online users
 * @param {Array} prevList - previously fetched list of online users
 */
const filterDuplicatedUsers = (newList, prevList) => {
  let filteredList = [...newList];
  for (let user of prevList) {
    filteredList = filteredList.filter((item) => item.id !== user.id);
  }

  return [...prevList, ...filteredList];
};

const generalDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //
    case generalData_Types.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };

    case generalData_Types.SET_ONLINE_USERS_BADGE:
      return {
        ...state,
        onlineUsersBadge: action.payload,
      };

    case generalData_Types.SET_ONLINE_USERS: {
      return {
        ...state,
        onlineUsers: {
          ...state.onlineUsers,
          loading: false,
          data: filterDuplicatedUsers(
            action.payload.list,
            state.onlineUsers.data
          ),
          page: action.payload.page || state.onlineUsers.page,
        },
      };
    }

    case generalData_Types.ADD_ONLINE_USER:
      return {
        ...state,
        onlineUsersBadge: state.onlineUsersBadge + 1,
        onlineUsers: {
          ...state.onlineUsers,
          data: [...state.onlineUsers.data, action.payload],
        },
      };

    case generalData_Types.REMOVE_ONLINE_USER:
      let adaptedOnlineUsers = state.onlineUsers.data.filter(
        (user) => user.id !== action.payload
      );
      const newBadgeCount = state.onlineUsersBadge - 1;
      return {
        ...state,
        onlineUsersBadge: newBadgeCount > 0 ? newBadgeCount : 0,
        onlineUsers: {
          ...state.onlineUsers,
          data: adaptedOnlineUsers,
        },
      };

    case generalData_Types.SET_SHOW_NOTIF_POPUP_DISPLAY: {
      return {
        ...state,
        showNotifPopup: action.payload,
      };
    }

    case generalData_Types.SET_FETCH_ONLINE_USERS_LOADING_STATUS: {
      return {
        ...state,
        onlineUsers: {
          ...state.onlineUsers,
          loading: action.payload,
        },
      };
    }

    case generalData_Types.RESET_STORE_STATE: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};

export default generalDataReducer;
